module.exports = __webpack_public_path__ + "static/img/s72.c301f664.png";